import React from "react";

const CGV = () => {
  const [size, setSize] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  React.useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <div
        class="row"
        style={{ maxWidth: size.width >= 428 && "76%", margin: "0px auto" }}
      >
        <div
          class="col-75"
          style={{
            marginLeft: size.width <= 428 && 20,
            marginRight: size.width <= 428 && 20,
            padding: 0,
            marginBottom: 30,
          }}
        >
          <div
            class="container"
            style={{ padding: size.width <= 428 ? 16 : 0 }}
          >
            <h1
              className="rservez-vos-rendez raleway-extra-bold-eerie-black-50px"
              style={{ paddingBottom: 10, fontSize: "35px", marginTop: 50 }}
            >
              Conditions générales de ventes
              <br />
            </h1>
            <p
              class="address subtitle raleway-medium-dove-17px "
              style={{ paddingBottom: 61 }}
            >
              En vigueur au 01/06/2022
            </p>
            <p className="roboto-normal-black-18px">
              Les présentes conditions générales d'utilisation (dites «
              <b>CGU</b>») ont pour objet l'encadrement juridique des modalités
              de mise à disposition du site et des services par On Fleek et de
              définir les conditions d’accès et d’utilisation des services par «
              l'Utilisateur ». Les présentes CGU sont accessibles sur le site à
              la rubrique «CGU». Toute inscription ou utilisation du site
              implique l'acceptation sans aucune réserve ni restriction des
              présentes CGU par l’utilisateur. Lors de l'inscription sur le site
              via le Formulaire d’inscription, chaque utilisateur accepte
              expressément les présentes CGU en cochant la case précédant le
              texte suivant : « J’accepte les CGU ». En cas de non-acceptation
              des CGU stipulées dans le présent contrat, l'Utilisateur se doit
              de renoncer à l'accès des services proposés par le site.
              www.onfleek.re se réserve le droit de modifier unilatéralement et
              à tout moment le contenu des présentes CGU.
            </p>
            <p className="raleway-bold-black-22px" style={{ marginTop: 30 }}>
              Définitions
            </p>
            <p style={{ marginTop: 20 }} className="roboto-normal-black-18px">
              <span className="raleway-bold-black-16px">Utilisateur : </span>
              tout professionnel ou personne physique capable au sens des
              articles 1123 et suivants du Code civil, ou personne morale, qui
              visite le Site objet des présentes conditions générales.
            </p>
            <p style={{ marginTop: 20 }} className="roboto-normal-black-18px">
              <span className="raleway-bold-black-16px">Contenu : </span>
              Ensemble des éléments constituants l’information présente sur le
              Site, notamment textes – images – vidéos.
            </p>
            <p style={{ marginTop: 20 }} className="roboto-normal-black-18px">
              <span className="raleway-bold-black-16px">
                Informations l'Utilisateur :{" "}
              </span>
              Ci après dénommé « Information (s) » qui correspondent à
              l’ensemble des données personnelles susceptibles d’être détenues
              par www.onfleek.re pour la gestion de votre compte, de la gestion
              de la relation client et à des fins d’analyses et de statistiques.
            </p>
            <p style={{ marginTop: 20 }} className="roboto-normal-black-18px">
              <span className="raleway-bold-black-16px">Prestataire : </span>
              Professionnel inscrit sur le site souhaitant proposer ses services
              aux utilisateur et bénéficier des servies proposés par
              www.onfleek.re
            </p>
            <p style={{ marginTop: 20 }} className="roboto-normal-black-18px">
              <span className="raleway-bold-black-16px">
                Informations personnelles :{" "}
              </span>
              « Les informations qui permettent, sous quelque forme que ce soit,
              directement ou non, l'identification des personnes physiques
              auxquelles elles s'appliquent » (article 4 de la loi n° 78-17 du 6
              janvier 1978).
            </p>
            <p style={{ marginTop: 20 }} className="roboto-normal-black-18px">
              Les termes « données à caractère personnel », « personne concernée
              », « sous traitant » et « données sensibles » ont le sens défini
              par le Règlement Général sur la Protection des Données (RGPD : n°
              2016-679)
            </p>
            <p className="raleway-bold-black-22px" style={{ marginTop: 30 }}>
              Article 1 : Les mentions légales
            </p>
            <p style={{ marginTop: 20 }} className="roboto-normal-black-18px">
              L'édition du site www.onfleek.re est assurée par la Société SAS On
              Fleek Technologies au capital de 1000 euros, immatriculée au RCS
              de Saint-Pierre sous le numéro 913 914 693, dont le siège social
              est situé au 27 avenue du Dr Jean Marie Dambreville Bâtiment alpha
              Parc techsud 97410 Saint-Pierre
              <br />
              Numéro de téléphone 0692909119 <br />
              Adresse e-mail : gregory@onfleek.re. <br />
              Le Directeur de la publication est : Grégory Desbois <br />
              <br />
              L'hébergeur du site www.onfleek.re est la société Firebase, dont
              le siège social est situé au 188 King ST, San Francisco, CA 94107,
              United States.
            </p>
            <p className="raleway-bold-black-22px" style={{ marginTop: 30 }}>
              Article 2 : Accès au site
            </p>
            <p className="roboto-normal-black-18px" style={{ marginTop: 20 }}>
              Le site www.onfleek.re &nbsp;permet &agrave; l&#39;Utilisateur un
              acc&egrave;s gratuit aux services suivants :
              <br /> <br />
              Le service permet de mettre en relation des professionnels du
              secteur de la beaut&eacute; proposant leurs services et les
              visiteurs sur le site (l&rsquo;Utilisateur). Les clients peuvent
              effectuer une r&eacute;servation de rendez-vous en ligne, et aussi
              dans certains cas, payer un acompte afin de confirmer cette dite
              r&eacute;servation.
              <br /> <br />
              Le site est accessible gratuitement en tout lieu &agrave; tout
              Utilisateur ayant un acc&egrave;s &agrave; Internet. Tous les
              frais support&eacute;s par l&#39;Utilisateur pour acc&eacute;der
              au service (mat&eacute;riel informatique, logiciels, connexion
              Internet, etc.) sont &agrave; sa charge.
              <br /> <br />
              L&rsquo;Utilisateur non membre n&#39;a pas acc&egrave;s aux
              services r&eacute;serv&eacute;s. Pour cela, il doit
              s&rsquo;inscrire en remplissant le formulaire. En acceptant de
              s&rsquo;inscrire aux services r&eacute;serv&eacute;s,
              l&rsquo;Utilisateur membre s&rsquo;engage &agrave; fournir des
              informations sinc&egrave;res et exactes concernant son &eacute;tat
              civil et ses coordonn&eacute;es, notamment son adresse email.
              <br /> <br />
              Pour acc&eacute;der aux services, l&rsquo;Utilisateur doit ensuite
              s&#39;identifier &agrave; l&#39;aide de son identifiant et de son
              mot de passe qui lui seront communiqu&eacute;s apr&egrave;s son
              inscription.
              <br /> <br />
              Tout Utilisateur membre r&eacute;guli&egrave;rement inscrit pourra
              &eacute;galement solliciter sa d&eacute;sinscription en se rendant
              &agrave; la page d&eacute;di&eacute;e sur son espace personnel.
              Celle-ci sera effective dans un d&eacute;lai raisonnable.
              <br /> <br />
              Tout &eacute;v&eacute;nement d&ucirc; &agrave; un cas de force
              majeure ayant pour cons&eacute;quence un dysfonctionnement du site
              ou serveur et sous r&eacute;serve de toute interruption ou
              modification en cas de maintenance, n&#39;engage pas la
              responsabilit&eacute; de www.onfleek.re. Dans ces cas,
              l&rsquo;Utilisateur accepte ainsi ne pas tenir rigueur &agrave;
              l&rsquo;&eacute;diteur de toute interruption ou suspension de
              service, m&ecirc;me sans pr&eacute;avis.
              <br /> <br />
              L&#39;Utilisateur a la possibilit&eacute; de contacter le site par
              messagerie &eacute;lectronique &agrave; l&rsquo;adresse email de
              l&rsquo;&eacute;diteur communiqu&eacute; &agrave; l&rsquo;ARTICLE
              1.
            </p>

            <p className="raleway-bold-black-22px" style={{ marginTop: 30 }}>
              Article 3 : Le paiement en ligne
            </p>

            <p className="roboto-normal-black-18px" style={{ marginTop: 20 }}>
              Certains prestataires exigent de payer un acompte directement en
              ligne afin de bloquer la r&eacute;servation. Celui-ci est
              r&eacute;alis&eacute; gr&acirc;ce au service propos&eacute; par
              Stripe. En cas de paiement en ligne par l&rsquo;Utilisateur,
              celui-ci doit communiquer ses coordonn&eacute;es bancaires, qui
              seront trait&eacute;es par On Fleek et Stripe, aux seules fins de
              gestion du paiement de l&rsquo;acompte.
              <br /> <br />
              En contrepartie de l&rsquo;utilisation du service de paiement en
              ligne, On Fleek et Stripe pr&eacute;l&egrave;vent &agrave;
              l&rsquo;Utilisateur, des frais suppl&eacute;mentaires de service
              (les &laquo; Frais de Service &raquo;) compos&eacute;s de frais
              fixes de 1&euro; (un euro) par transaction du montant TTC (toutes
              taxes comprises) de la prestation.
              <br /> <br />
              Ainsi, le prix pay&eacute; par l&rsquo;Utilisateur se
              d&eacute;compose comme suit :
              <br />
              <ul>
                <li>
                  &bull; Prix de la prestation ; <br />
                </li>
                <li>
                  &bull; Frais de Service. <br />
                </li>
              </ul>
              <br /> <br /> <br />
              Le service n&rsquo;est qu&rsquo;un moyen de mise en relation entre
              le Prestataire et l&rsquo;Utilisateur. Ni On Fleek, ni Stripe
              n&#39;interviennent dans cette relation. Le prix de la prestation
              est donc fix&eacute; par le Prestataire.
              <br /> <br />
              Le paiement se fait par carte bancaire selon les conditions
              d&eacute;finies par le Prestataire au moment de la validation du
              rendez-vous. Le paiement est s&eacute;curis&eacute; et les
              Conditions de Service de Stripe s&rsquo;appliquent lors de
              l&rsquo;utilisation de ce mode de paiement.
              <br /> <br />
              La responsabilit&eacute; de www.onflee.re ne peut &ecirc;tre
              engag&eacute;e en cas de probl&egrave;me lors du paiement,
              qu&rsquo;il ait lieu en ligne ou directement aupr&egrave;s du
              Prestataire.
            </p>

            <p className="raleway-bold-black-22px" style={{ marginTop: 30 }}>
              Article 4 : Collecte des données
            </p>

            <p className="roboto-normal-black-18px" style={{ marginTop: 20 }}>
              Le site assure &agrave; l&#39;Utilisateur une collecte et un
              traitement d&#39;informations personnelles dans le respect de la
              vie priv&eacute;e conform&eacute;ment &agrave; la loi n&deg;78-17
              du 6 janvier 1978 relative &agrave; l&#39;informatique, aux
              fichiers et aux libert&eacute;s. <br />
              En vertu de la loi Informatique et Libert&eacute;s, en date du 6
              janvier 1978, l&#39;Utilisateur dispose d&#39;un droit
              d&#39;acc&egrave;s, de rectification, de suppression et
              d&#39;opposition de ses donn&eacute;es personnelles.
              <br />
              <br />
              L&#39;Utilisateur exerce ce droit :
              <br />
              <ul>
                <li>
                  &bull; par mail &agrave; l&#39;adresse email hello@onfleek.re
                  <br />
                </li>
                <li>
                  &bull; par voie postale au je suis une 27 avenue du Dr Jean
                  Marie Dambreville Bâtiment alpha Parc techsud 97410
                  Saint-Pierre ; <br />
                </li>
              </ul>
            </p>
            <p className="raleway-bold-black-22px" style={{ marginTop: 30 }}>
              Article 5 : Propriété intellectuelle
            </p>

            <p className="roboto-normal-black-18px" style={{ marginTop: 20 }}>
              Les marques, logos, signes ainsi que tous les contenus du site
              (textes, images, son&hellip;) font l&#39;objet d&#39;une
              protection par le Code de la propri&eacute;t&eacute;
              intellectuelle et plus particuli&egrave;rement par le droit
              d&#39;auteur.
              <br />
              <br />
              L&#39;Utilisateur doit solliciter l&#39;autorisation
              pr&eacute;alable du site pour toute reproduction, publication,
              copie des diff&eacute;rents contenus. Il s&#39;engage &agrave; une
              utilisation des contenus du site dans un cadre strictement
              priv&eacute;, toute utilisation &agrave; des fins commerciales et
              publicitaires est strictement interdite.
              <br />
              Toute repr&eacute;sentation totale ou partielle de ce site par
              quelque proc&eacute;d&eacute; que ce soit, sans
              l&rsquo;autorisation expresse de l&rsquo;exploitant du site
              Internet constituerait une contrefa&ccedil;on sanctionn&eacute;e
              par l&rsquo;article L 335-2 et suivants du Code de la
              propri&eacute;t&eacute; intellectuelle.
              <br />
              Il est rappel&eacute; conform&eacute;ment &agrave; l&rsquo;article
              L122-5 du Code de propri&eacute;t&eacute; intellectuelle que
              l&rsquo;Utilisateur qui reproduit, copie ou publie le contenu
              prot&eacute;g&eacute; doit citer l&rsquo;auteur et sa source.
            </p>
            <p className="raleway-bold-black-22px" style={{ marginTop: 30 }}>
              Article 6 : Responsabilité
            </p>

            <p className="roboto-normal-black-18px" style={{ marginTop: 20 }}>
              Les sources des informations diffus&eacute;es sur le site
              www.onfleek.re sont r&eacute;put&eacute;es fiables mais le site ne
              garantit pas qu&rsquo;il soit exempt de d&eacute;fauts,
              d&rsquo;erreurs ou d&rsquo;omissions.
              <br />
              Les informations communiqu&eacute;es sont pr&eacute;sent&eacute;es
              &agrave; titre indicatif et g&eacute;n&eacute;ral sans valeur
              contractuelle. Malgr&eacute; des mises &agrave; jour
              r&eacute;guli&egrave;res, le site www.onfleek.re ne peut
              &ecirc;tre tenu responsable de la modification des dispositions
              administratives et juridiques survenant apr&egrave;s la
              publication. De m&ecirc;me, le site ne peut &ecirc;tre tenu
              responsable de l&rsquo;utilisation et de
              l&rsquo;interpr&eacute;tation de l&rsquo;information contenue dans
              ce site.
              <br />
              L&#39;Utilisateur s&#39;assure de garder son mot de passe secret.
              Toute divulgation du mot de passe, quelle que soit sa forme, est
              interdite. Il assume les risques li&eacute;s &agrave;
              l&#39;utilisation de son identifiant et mot de passe. Le site
              d&eacute;cline toute responsabilit&eacute;.
              <br />
              Le site www.onfleek.re ne peut &ecirc;tre tenu pour responsable
              d&rsquo;&eacute;ventuels virus qui pourraient infecter
              l&rsquo;ordinateur ou tout mat&eacute;riel informatique de
              l&rsquo;Internaute, suite &agrave; une utilisation, &agrave;
              l&rsquo;acc&egrave;s, ou au t&eacute;l&eacute;chargement provenant
              de ce site.
              <br />
              La responsabilit&eacute; du site ne peut &ecirc;tre engag&eacute;e
              en cas de force majeure ou du fait impr&eacute;visible et
              insurmontable d&#39;un tiers.
            </p>

            <p className="raleway-bold-black-22px" style={{ marginTop: 30 }}>
              Article 7 : Liens hypertextes
            </p>
            <p className="roboto-normal-black-18px" style={{ marginTop: 20 }}>
              Des liens hypertextes peuvent être présents sur le site.
              L’Utilisateur est informé qu’en cliquant sur ces liens, il sortira
              du site www.onfleek.re. Ce dernier n’a pas de contrôle sur les
              pages web sur lesquelles aboutissent ces liens et ne saurait, en
              aucun cas, être responsable de leur contenu.
            </p>
            <p className="raleway-bold-black-22px" style={{ marginTop: 30 }}>
              Article 8 : Cookies
            </p>
            <p className="roboto-normal-black-18px" style={{ marginTop: 20 }}>
              L&rsquo;Utilisateur est inform&eacute; que lors de ses visites sur
              le site, un cookie peut s&rsquo;installer automatiquement sur son
              logiciel de navigation.
              <br />
              Les cookies sont de petits fichiers stock&eacute;s temporairement
              sur le disque dur de l&rsquo;ordinateur de l&rsquo;Utilisateur par
              votre navigateur et qui sont n&eacute;cessaires &agrave;
              l&rsquo;utilisation du site www.onfleek.re. Les cookies ne
              contiennent pas d&rsquo;information personnelle et ne peuvent pas
              &ecirc;tre utilis&eacute;s pour identifier quelqu&rsquo;un. Un
              cookie contient un identifiant unique, g&eacute;n&eacute;r&eacute;
              al&eacute;atoirement et donc anonyme. Certains cookies expirent
              &agrave; la fin de la visite de l&rsquo;Utilisateur,
              d&rsquo;autres restent.
              <br />
              L&rsquo;information contenue dans les cookies est utilis&eacute;e
              pour am&eacute;liorer le site www.onfleek.re.
              <br />
              En naviguant sur le site, L&rsquo;Utilisateur les accepte.
              <br />
              L&rsquo;Utilisateur doit toutefois donner son consentement quant
              &agrave; l&rsquo;utilisation de certains cookies.
              <br />
              A d&eacute;faut d&rsquo;acceptation, l&rsquo;Utilisateur est
              inform&eacute; que certaines fonctionnalit&eacute;s ou pages
              risquent de lui &ecirc;tre refus&eacute;es.
              <br />
              L&rsquo;Utilisateur pourra d&eacute;sactiver ces cookies par
              l&rsquo;interm&eacute;diaire des param&egrave;tres figurant au
              sein de son logiciel de navigation.
            </p>
            <p className="raleway-bold-black-22px" style={{ marginTop: 30 }}>
              Article 9 : Droit applicable et juridiction compétente
            </p>
            <p className="roboto-normal-black-18px" style={{ marginTop: 20 }}>
              La législation française s'applique au présent contrat. En cas
              d'absence de résolution amiable d'un litige né entre les parties,
              les tribunaux français seront seuls compétents pour en connaître.
              <br />
              Pour toute question relative à l’application des présentes CGU,
              vous pouvez joindre l’éditeur aux coordonnées inscrites à
              l’ARTICLE 1.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default CGV;
